import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogData: any = {
    header: 'header',
    type: 'confirm',
    isOpen: false,
    isSessionDialogOpen: false,
    buttons: {
      accept: {
        text: 'Yes, Remove',
        action: () => {
          console.log("Accepted");
        },
        background: "#cccc",
        color: '#fff'
      },
      reject: {
        text: 'No',
        action: () => {
          console.log("Rejected");
        },
        background: "#cccc",
        color: '#fff'
      },
    },
  };

  private toasterData: any = {
    content: '',
    type: 'undo',
    hasUndo: false,
    severity: 'success',
    undo: {
      text: 'undo',
      action: () => { }
    },
    close: () => { },
    position: 'bottom-center'
  };

  public dialogDataPromise = new BehaviorSubject<string>(null);
  public $dialogData = this.dialogDataPromise.asObservable();

  public toasterDataPromise = new BehaviorSubject<string>(null);
  public $toasterData = this.toasterDataPromise.asObservable();

  private sharedDialogPromise = new BehaviorSubject<DialogConfig>(null);
  public $sharedDialog = this.sharedDialogPromise.asObservable();

  constructor() {

  }

  showDialog(config: DialogConfig) {
    this.sharedDialogPromise.next(config);
  }

  public updateDialogData(data: string) {
    this.dialogDataPromise.next(data);
  }


  public updateToasterData(data: string) {
    this.toasterDataPromise.next(data);
  }

  public getToasterData(isDeep: boolean = true) {
    let data: any = {};
    if (isDeep) {
      data = JSON.parse(JSON.stringify(this.toasterData));
    } else {
      data = JSON.parse(JSON.stringify(this.toasterData));
      data.undo.action = () => { };
      data.close = () => { };
    }
    data.type = 'undo';
    return data;
  }

  public getConfirmData(isDeep: boolean = true) {
    let data: any = {};
    if (isDeep) {
      data.isOpen = true;
      data = JSON.parse(JSON.stringify(this.dialogData));
    } else {
      data = this.dialogData;
    }
    data.type = 'confirm';
    return data;
  }
}

export interface DialogConfig {
  type: BdpDialogTypes;
  visibility: boolean;
  width: string;
  header: string;
  body: string;
  placeholder?: string;
  action?: string;
  reject?: string;
  onAccept?: InputCallbackFunc;
  onReject?: CallbackFunc;
}

export interface InputDialogConfig {
  type: BdpDialogTypes;
  visibility: boolean;
  width: string;
  header: string;
  body: string;
  placeholder: string;
  maxLength?: number,
  message: string,
  action?: string;
  onAccept?: InputCallbackFunc;
  onReject?: CallbackFunc;
}

export enum BdpDialogTypes {
  CONFIRM = 'confirm',
  INFO = 'info',
  INPUT = 'input',
  SESSION = 'session',
  SIGN_OUT = 'signOut'
}

interface CallbackFunc {
  (): any;
}

interface InputCallbackFunc {
  (data: any): any;
}
